import styles from './Login.module.css';

import React, { useState } from 'react';

import { isPasswordFormatValid } from './authHelpers';

interface PasswordFieldProps {
  label: string;
  onForgotPassword?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  onPasswordChange: (password: string) => void;
  showError?: boolean;
}

const PasswordField = (
  {
    label,
    onForgotPassword,
    onPasswordChange,
    showError = true
  } : PasswordFieldProps): React.JSX.Element => {

  const [isPasswordVisible, setIsPasswordVisible] = useState<boolean>(false);
  const [passwordError, setPasswordError] = useState<string>('');

  const handlePasswordBlur = (email: string): void => {
    if (!isPasswordFormatValid(email)) {
      setPasswordError('Please enter a valid password.');
    } else {
      setPasswordError('');
    }
  };

  const handlePasswordChange = (email: string): void => {
    onPasswordChange(email);
    if (isPasswordFormatValid(email)) {
      setPasswordError('');
    }
  };

  const togglePasswordVisibility = (): void => setIsPasswordVisible(v => !v);

  return (
    <div className={styles['form-field']}>
      <div className={styles['login-field-label-row']}>
        <label className={styles['label-login-field']} htmlFor="password">{label} <span className={styles['label-required-star']}>*</span></label>
      </div>

      <div className={styles['password-field']}>
        <input
          className={styles['input-login-field']}
          id="password"
          data-testid="password-input"
          type={isPasswordVisible ? 'text' : 'password'}
          onBlur={e => handlePasswordBlur(e.target.value)}
          onChange={e => handlePasswordChange(e.target.value)}
          required
        />
        <button type="button" className={styles['password-toggle-btn']} onClick={togglePasswordVisibility}>
          {isPasswordVisible ? 'Hide' : 'Show'}
        </button>
      </div>

      {onForgotPassword &&
        <div className={styles['password-forgot-link-container']}>
          <a
            className={styles['password-forgot-link']}
            href="/#noop"
            onClick={onForgotPassword}
            data-testid="forgot-password-link"
          >
            Forgot my password
          </a>
        </div>
      }

      {passwordError && showError && <div className={styles['login-error-message']}>{passwordError}</div>}
    </div>
  );
};
export default PasswordField;
